import * as Html from "../../util/Html.ts";
import * as modal from "../../util/modal.ts";
import * as i18n from "../../i18n.ts";
import * as rrule from "../../lib/rrule/rrule.js";
import * as rrulewriter from "../../lib/rrule/rrule-writer.js";
import * as DateUtils from "../../lib/DateUtils.ts";
import TPL from "../../modal/recurrency-custom.mustache";
import * as RRuleHelper from "../../lib/rrule/RRuleHelper.js";

const RRule = rrule.RRule;
export {init}

Html.registerWidget('widget/form/recurrency',{init:init})

var 
  DAYSOFWEEK = ["SU","MO","TU","WE","TH","FR","SA"];

function init(obj){
  var 
    
    originalForm = obj.parents('form'),
    startDateInput = originalForm.find('[name="startDate"],[name="dueDate"]'),
    select = obj.find('select'),
    previousValue,
    recurrencyInput = obj.find('[name="recurrency"]'),
    intervalInput = obj.find('[name="recurrencyInterval"]'),
    byDayInput = obj.find('[name="byDay"]'),
    byMonthDayInput = obj.find('[name="byMonthDay"]');

  function getStartDate(){
    return startDateInput.localDateValue()
  }
  
  function getCurrentDayOfWeek(){
    var 
      startDate = getStartDate();
    if(!startDate) return null;  
    return DAYSOFWEEK[startDate.getDay()%7];
  }
  function getMonthPossibility(){
    var 
      startDate = getStartDate(),
      weekdayIdx = startDate.getDay()-1,
      dayOfWeek = DAYSOFWEEK[(weekdayIdx+1)%7],
      result = [{key:"",text:rrulewriter.write({simple:true,freq:1,bymonthday:startDate.getDate()})}],
      month = startDate.getMonth();
    
    for(var i=1;i<5;i++){
      if(DateUtils.dateAdd(startDate,{day:-7*i}).getMonth()!==month){
        let 
          byDay = i+dayOfWeek;
        result.push({key:byDay,text:rrulewriter.write({simple:true,freq:1,byweekday:[{n:i,weekday:weekdayIdx}]})});
        break;
      }
    }
    for(var i=1;i<2;i++){
      if(DateUtils.dateAdd(startDate,{day:7*i}).getMonth()!==month){
        let 
          byDay = "-"+i+dayOfWeek;
        result.push({key:byDay,text:rrulewriter.write({simple:true,freq:1,byweekday:[{n:-i,weekday:weekdayIdx}]})});
        break;
      }
    }
    if(DateUtils.getRelativeDayToNextMonth(startDate)===-1){
        result.push({key:"-1",text:i18n.get('recurrency.lastofmonth')});
    }
    return result
  }
  
  startDateInput.on('change',function(evt){
    if(select.val()==='NONE' || select.val()==='CUSTOM') return;
    if(!startDateInput.dateValue()){
      select.val('NONE').trigger('change')
    }else{
      assignSimplifiedRrule(select.val())
      
    }
  })
  function assignSimplifiedRrule(input){
    //we show or hide last of month
    var lastOfMonthOption = select.find('option[value="FREQ=MONTHLY;BYMONTHDAY=-1"]');
    if(DateUtils.getRelativeDayToNextMonth(getStartDate())===-1){
      lastOfMonthOption.show(); 
    }else{
      lastOfMonthOption.hide();
    }
    //we handle cutom
    var simplifiedStr = RRuleHelper.simplify(input)
    select.find('option[data-custom]').remove();
    
    //we verify if it is good and if not we fallback to simple recurrency
    var options = new RRuleHelper.RRuleOptions(simplifiedStr)
    if(!options.verify(startDateInput.dateValue())){
      select.val('FREQ='+options.freq)
    }else if(select.find('option[value="'+simplifiedStr+'"]').length){
      select.val(simplifiedStr);
    }else{
      select.append($('<option value="'+simplifiedStr+'" selected data-custom="true">'+rrulewriter.write(RRule.parseString(input))+'</option>'))
    }
    select.trigger('change')
  }
  
  
  select.on('change',function(evt){
    var val = select.val();
    
    if(val!=='NONE' && !startDateInput.dateValue()){
      var now = new Date();
      now.setHours(now.getHours()+1);
      now.setMinutes(now.getMinutes()-now.getMinutes()%5);
      startDateInput.dateValue(now);
    }
    if(val==='CUSTOM'){
      select.val(previousValue);
      var 
        startDayOfWeek = getCurrentDayOfWeek(),
        byDayMonth = byDayInput.val(),
        themodal = modal.openModal(TPL,{
          recurrencyInterval:Number(intervalInput.val()) || 1,
          recurrency:recurrencyInput.val(),
          byDay:byDayInput.val()||startDayOfWeek,
          dayOfWeek:DateUtils.getWeekDays(),
          monthPossibility : getMonthPossibility()
        }),
        theForm = themodal.find('form').get(0),
        recurrencyInput2 = themodal.find('[name="recurrency"]'),
        intervalInput2 = themodal.find('[name="recurrencyInterval"]'),
        recap = themodal.find('.fw-recurrency'),
        weeklyNode = themodal.find('.fw-recurrency-weekly'),
        weeklyByDayInput = weeklyNode.find('[name="byDay"]'),
        monthlyNode = themodal.find('.fw-recurrency-monthly');
      
      weeklyNode
        .find('[data-byday]')
        .each(function(idx,node){
          node = $(node);
          if(node.attr("data-byday")===startDayOfWeek){
            node.addClass('fw-background-branded');
            node.addClass('fw-locked')
          }else{
            node.css('cursor','pointer')
          }
          var selected = weeklyByDayInput.val().indexOf(node.attr("data-byday"))!==-1;
          node.toggleClass("fw-background-branded",selected)
          node.toggleClass("border-branded",selected)
          
        }).on('click',function(){
          if($(this).attr("data-byday")===startDayOfWeek){
            return;
          }
          $(this).toggleClass('fw-background-branded');
          $(this).toggleClass('border-branded');
          var byDayVal = $.map(weeklyNode.find('[data-byday].fw-background-branded'),function(node){
            return $(node).attr("data-byday");
          });
          weeklyByDayInput.val(byDayVal.join(','));
          maj();
        })
      monthlyNode
        .find('input')
        .each(function(idx,radio){
          //console.log(radio.value,byDayMonth,radio.value==byDayMonth)
          // ==  is here on purpose
          if(radio.value==byDayMonth){
            radio.checked=true;
          }
        });
        
      function maj(){
        weeklyNode.toggle(recurrencyInput2.val()==='WEEKLY');
        monthlyNode.toggle(recurrencyInput2.val()==='MONTHLY');
        if(recurrencyInput2.val()==='MONTHLY'){
          recap.html('')
        }else{
          var options =  {
            freq:['YEARLY','MONTHLY','WEEKLY','DAILY'].indexOf(recurrencyInput2.val()),
            interval:intervalInput2.val(),
            byweekday:$.map(weeklyByDayInput.val().split(','),function(item){
              return {weekday:(DAYSOFWEEK.indexOf(item)+6)%7};
            })
          }
          recap.html(rrulewriter.write(options));
        }
       
      }
      
      recurrencyInput2.on('change',maj)
      intervalInput2.on('change',function(){
        var val = Number(this.value||1)
        if(val>this.max){
          this.value=this.max;
        }else if(val<this.min){
          this.value=this.min;
        }
        maj();
      })
      recurrencyInput2.find('option').each(function(idx,option){
        if(option.value===recurrencyInput.val()){
          option.selected=true;
        }
      })
      maj();
      
      themodal.find('[data-button="ok"]').on('click',function(evt){
        evt.preventDefault();
        var res = "FREQ="+ recurrencyInput2.val()
          +";INTERVAL="+intervalInput2.val();
        if(recurrencyInput2.val()==='WEEKLY' && weeklyByDayInput.val()){
          res += ";BYDAY="+weeklyByDayInput.val()
        }
        if(recurrencyInput2.val()==='MONTHLY'){
          var value = theForm.monthpossibility.value;
          if(value.match(/[A-Z]+/)){
            res += ";BYDAY="+value
          }else{
            res += ";BYMONTHDAY="+value
          }
          
        }
        assignSimplifiedRrule(res);
        modal.closeModal(themodal);
      })
      themodal.find('[data-button="cancel"]').on('click',function(evt){
        evt.preventDefault();
        modal.closeModal(themodal);
      })
    }
    
    //maj others inputs
    if(val==='NONE'){
      recurrencyInput.val('NONE');
      intervalInput.val(1);
    }else if(val==='CUSTOM'){
      recurrencyInput.val('NONE');
      intervalInput.val(1);
    }else{
      var simplifiedOptions = RRuleHelper.asFamilywallForm(val);
      recurrencyInput.val(simplifiedOptions.recurrency);
      intervalInput.val(simplifiedOptions.recurrencyInterval);
      byDayInput.val(simplifiedOptions.byDay);
      byMonthDayInput.val(simplifiedOptions.byMonthDay);
    }
    previousValue = select.val()
  });
  assignSimplifiedRrule(select.attr('rrule'))
  
}
